import React,{ useState }  from 'react';
import {Accordion,AccordionItem,AccordionItemButton,AccordionItemHeading,AccordionItemPanel,AccordionItemState} from "react-accessible-accordion";
import 'react-accessible-accordion/dist/fancy-example.css';
import {MdOutlineArrowDropDown } from "react-icons/md";
import "./Value.css";
import data from "../../utils/Accordion";

const Value = ({ refProp }) => {
  const [className, setClassName] = useState(null);
  return (
    <>
     <section ref={refProp}> 

    <div className="v-wrapper">
    <div className="left">
    <img src="./main3.jpg" alt="left" />
    </div>

    <div className="right">
      <span className='orange'>Our Value </span>
      <span className='secondary'>Value we give to you </span>
      <span> We always help you to find the best suitable property <br />
      Best services
      you cann get property which can have great value in future.</span>

      <Accordion className='accordion'
      allowMultipleExpanded={false}
      preExpanded={[0]} >
        { data.map( (item,i)=>{
          return (
            <AccordionItem className={`accordionItem ${className}`} key={i} uuid={i}>
            <AccordionItemHeading>
            <AccordionItemButton>
            <AccordionItemState>
            {({ expanded }) =>
                          expanded
                            ? setClassName("expanded")
                            : setClassName("collapsed")
             }
              
            </AccordionItemState>
              <span className="icon">{item.icon}</span>
              <span className='primary'>{item.heading}</span>
              <span>
                <MdOutlineArrowDropDown size={20}/>
              </span>
            </AccordionItemButton>

            </AccordionItemHeading>
            <AccordionItemPanel>
              <p className='secondaryText'>
                {item.detail}
              </p>
            </AccordionItemPanel>

            </AccordionItem>


          )



        })


        }

      </Accordion>


    </div>

    </div>
    </section>
    </>
  )
}

export default Value
